import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import Form from '../../components/Form/Form';
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from '../../services/data.service';
import Unauthorized from './../Authentication/Unauthorized';
import Departments_popup_CreateDepartment from './Popups/Departments_popup_CreateDepartment';

const DepartmentsView: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleException, handleResult } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate()

    useEffect(() => {
        getTableData()
    }, [])

    function getTableData() {
        setShowSpinner(true);
        DataService
            .get<any[]>(`api/v1/Departments/`)
            .then(response => {
                setShowSpinner(false);
                setData(response);
            })
            .catch(e => {
                setShowSpinner(false);
                handleException(e)
            });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/Departments/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function hidePopup(departmentId?: number) {
        setShowPopup(false)
        if (departmentId) {
            getTableData()
            navigate('/plm/userManagement/department/' + departmentId)
        }
    }

    const colInfos: IColInfo[] = [
        { title: 'Id', key: true, dataProp: 'id', dataType: 'number', visible: false },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Manager', dataProp: 'manager.name', filterInfo: { filterType: 'Textbox' } },
    ];
    if (isAuthorizedFor(ApplicationFunctions.UpdateApplicationRole)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    if (!isAuthorizedFor(ApplicationFunctions.ViewApplicationRole)) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form>
                <Form.Header title="Departments" >
                    <ActionMenu title="Actions">
                        <ActionMenuItem width={300} icon="fa fa-plus" iconVariant="success" title={"Create new Department"} onClick={() => { setShowPopup(true); }} />
                    </ActionMenu>
                </Form.Header>
                <Form.Content>
                    <DataTable
                        name='dtDepartments'
                        colInfos={colInfos}
                        tableData={data}
                        navigateTitle='Department'
                        navigateUrl='/plm/UserManagement/Department/'
                    />
                </Form.Content>
            </Form>
            {showSpinner && (<SpinnerOverlay />)}
            {showPopup && (<Departments_popup_CreateDepartment show={showPopup} onHide={hidePopup} />)}
        </div>
    );
}
export default DepartmentsView;
